<template>
  <v-snackbar
    v-model="active"
    :timeout="timeout"
    :color="color"
    :bottom="y === 'bottom'"
    :top="y === 'top'"
    :left="x === 'left'"
    :right="x === 'right'"
    :auto-height="autoHeight"
    :multi-line="multiLine"
    :vertical="vertical"
    class="application"
    @click="dismiss"
  >
    {{ text }}
    <div v-if="!!icon" :class="['toast-icon', icon]"></div>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    x: {
      type: String,
      default: () => 'right'
    },
    y: {
      type: String,
      default: () => 'bottom'
    },
    color: {
      type: String,
      default: () => 'info'
    },
    icon: {
      type: String,
      default: () => ''
    },
    text: {
      type: String,
      default: () => ''
    },
    timeout: {
      type: Number,
      default: () => 3000
    },
    dismissable: {
      type: Boolean,
      default: () => true
    },
    autoHeight: {
      type: Boolean,
      default: () => false
    },
    multiLine: {
      type: Boolean,
      default: () => false
    },
    vertical: {
      type: Boolean,
      default: () => false
    }
  },

  data: () => ({
    active: false
  }),

  mounted() {
    this.$nextTick(() => this.show())
  },

  methods: {
    show(options = {}) {
      if (this.active) {
        this.close()
        this.$nextTick(() => this.show(options))
        return
      }
      Object.keys(options).forEach(field => (this[field] = options[field]))
      this.active = true
    },
    close() {
      this.active = false
    },
    dismiss() {
      if (this.dismissable) {
        this.active = false
      }
    }
  }
}
</script>

<style >
@keyframes async {
  0% {
    -webkit-transform: translate(0, -50%) rotate(0deg);
    transform: translate(0, -50%) rotate(0deg);
  }
  100% {
    -webkit-transform: translate(0, -50%) rotate(360deg);
    transform: translate(0, -50%) rotate(360deg);
  }
}

.v-snack--bottom {
  margin: 0;
  padding: 24px 20px 20px;
}
.v-snack__wrapper {
  border-radius: 0;
  width: 314px;
  height: 73px;
  font-size: 1rem;
  font-weight: 900;
  position: relative;
  line-height: 24px;
}
.v-snack__content {
  max-width: 250px;
}
.v-snack__wrapper.running {
  background-color: #19B0F0;
}
.v-snack__wrapper.ready {
  background-color: #70be4c;
  color: #fff;
}
.v-snack__wrapper.error {
  background-color: #323639 !important;
  color: #fff;
}

.toast-icon {
  position: absolute;
  right: 34px;
  top: 50%;
  line-height: 0;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  max-height: 48px;
  max-width: 48px;
  width: 40px;
  height: 40px;
}

.toast-icon.error {
  background: none !important;
}
.toast-icon.async {
  background-image: url("example-image-url.svg");
}
</style>
